import React from "react";
import styles from "./aPlusBZone.scss";
import SetBundleProduct from "../setBundleProduct/setBundleProduct";

const APlusBZone = (props) => {
  const {
    zone,
    quantities,
    onItemQuantityChange,
    disableButtons,
    loadingProduct,
  } = props;

  const selectedQuantity = Object.values(quantities).reduce(
    (total, quantity) => total + quantity,
    0
  );

  return (
    <div className={styles["container"]}>
      <div className={styles["header"]}>
        <span
          className={styles["title"]}
          style={{ backgroundColor: zone.backgroundColor }}
        >
          {zone.title}
        </span>
        <span className={styles["selected-products"]}>
          商品選擇數量: {selectedQuantity}
        </span>
      </div>
      <div className={styles["products"]}>
        {zone?.products?.map((product) => (
          <SetBundleProduct
            key={product.itemCode}
            product={product}
            quantity={quantities[product.itemCode]}
            onItemQuantityChange={onItemQuantityChange}
            disableButtons={disableButtons}
            loadingProduct={loadingProduct}
            // disableAddButtons={isProportionMatched}
          />
        ))}
      </div>
    </div>
  );
};

export default APlusBZone;
